<template>
  <div>
    <PCNavbar class="hidden-xs-only none_992" />
    <MobileNavBar class="hidden-md-and-up" />
    <!-- <CarouselHome /> -->
    <div class="new_body hidden-xs-only none_992">
      <img :src="imgList[0].src" alt="" class="img_item" />
      <div class="new_top">
      </div>
      <div class=tips_font>
        <div class="txt">新闻中心<span style="color: #FFF;opacity: 0.4;margin-left: 5px">NEWS</span></div>
      </div>
    </div>

    <div class="new_body_mobile hidden-md-and-up">
      <img :src="imgList[0].src" alt="" class="img_item" />
      <div class="new_top">
      </div>
      <div class=tips_font>
        <div class="txt">新闻中心<span style="color: #FFF;opacity: 0.4;margin-left: 5px">NEWS</span></div>
      </div>
    </div>
    <NewsList  class="hidden-xs-only none_992" />
    <NewsListMobile  class="hidden-md-and-up" />
    <CallMe class="hidden-xs-only none_992" />
    <MobileCallme class="hidden-md-and-up" />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import TodoShow from '@/components/todo_show/index'
import MainTop from '@/components/main_top/index'
import NewsList from '@/components/news_list/index'
import NewsListMobile from '@/components/news_list_mobile/index'
import TitleComponent from '@/components/titleComponent/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/callMeMile.vue'
export default {
  name: 'NewsCenter',
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    NewsList,
    CallMe,
    MainTop,
    TitleComponent,
    MobileCallme,
    NewsListMobile
  },
  data() {
    return {
      imgList: [
        {
          src: 'https://hr2.chnsoft.com.cn/img/newsTop.png',

        },
      ],
      currentSource: '', // 用于存储当前的 source 参数
      showVideoDialog: false, // 控制弹窗显示
      videoUrl: 'https://hr2.chnsoft.com.cn/img/video222.mp4', // 替换为实际视频路径
    };
  },
}
</script>

<style lang="scss" scoped>
.new_body {
  position: relative;

  .new_top {
    position: absolute;
    width: 100%;
    // height: 100%;
    top: 0px;
    // background: linear-gradient(180deg, rgba(28, 54, 93, 0.9) 0%, rgba(28, 54, 93, 0.3) 100%, rgba(28, 54, 93, 0) 100%);
  }

  img {
    /* 让图片宽度自适应容器，高度自适应原始比例，不拉伸不裁剪 */
    max-width: 100%;
    height: 680px;
    display: block;
    margin: 0 auto;
  }


  .tips_font {
    position: absolute;
    top: 290px;
    left: 0;
    z-index: 5;
    color: #fff;
    font-size: 25PX;
    width: 100%;

    .txt {
      font-family: PingFang SC;
      font-size: 42PX;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #FFFFFF;
      padding-left: 17%;
    }



    h1 {
      text-align: left;
      padding-left: 17%;
    }

    .content {
      padding: 1.5% 23%;
      font-size: 20PX;
      color: #fff;
      font-weight: normal; // 不加粗

      opacity: 0.8;
      width: 100%;
    }

  }
}

.new_body_mobile {
  position: relative;
// margin-top: 40PX;
  .new_top {
    position: absolute;
    width: 100%;
    // height: 100%;
    top: 0px;
    // background: linear-gradient(180deg, rgba(28, 54, 93, 0.9) 0%, rgba(28, 54, 93, 0.3) 100%, rgba(28, 54, 93, 0) 100%);
  }

  img {
    /* 让图片宽度自适应容器，高度自适应原始比例，不拉伸不裁剪 */
    width: 100%;
    height: 200PX;
    display: block;
    // margin: 0 auto;
  }


  .tips_font {
    position: absolute;
    top: 95PX;
    left: 0;
    z-index: 5;
    color: #fff;
    font-size: 21PX;
    width: 100%;

    .txt {
      font-family: PingFang SC;
      font-size: 21PX;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #FFFFFF;
      padding-left: 40PX;
    }



    h1 {
      text-align: left;
      padding-left: 17%;
    }

    .content {
      padding: 1.5% 23%;
      font-size: 20PX;
      color: #fff;
      font-weight: normal; // 不加粗

      opacity: 0.8;
      width: 100%;
    }

  }
}
</style>